import exportPdf from './exportPdf'

export default exportPdf
